/**
 * Generated by orval v6.20.0 🍺
 * Do not edit manually.
 * portrich-api
 * OpenAPI spec version: 0.0.0
 */

export type ShipmentsTasksSetCreateTaskType = typeof ShipmentsTasksSetCreateTaskType[keyof typeof ShipmentsTasksSetCreateTaskType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShipmentsTasksSetCreateTaskType = {
  Sub_Task: 'Sub Task',
  Task: 'Task',
} as const;
